import pagination from '@iso/lib/helpers/pagination';

const {
    actions: baseActions,
    types,
    reducer,
} = pagination('productSeasons');

const actions = {
    requestFetchProductSeasons: baseActions.request,
    fetchProductSeasonsSucceeded: baseActions.succeeded,
    fetchProductSeasonsFailed: baseActions.failed,
};

export { types, actions };

export default reducer;